import React, { useState } from 'react';
import Button from './button';

interface WaiverAnswersProps {
  data: any;
}

const WaiverAnswers = ({ data }: WaiverAnswersProps) => {
  const [visible, setVisible] = useState(false);

  return (
    <div>
      {visible && (
        <div style={{ paddingTop: '5px' }}>
          <strong>Answers copied:</strong>
          {data.waiver_answers.map((answer, index) => (
            <div key={index}>
              <br />
              <strong>{answer.question}</strong>
              <div>{answer.result}</div>
            </div>
          ))}
        </div>
      )}
      <div className="margtin-top-8">
        <Button variant="link" onClick={() => setVisible(!visible)}>
          {visible ? 'show less' : 'show more'}
        </Button>
      </div>
    </div>
  );
};

export default WaiverAnswers;
